import { Model } from "@vuex-orm/core";
import config from "../configs/Invoice";

export default class Invoice extends Model {
  static get entity() {
    return "invoices";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      building_id: this.attr(null),
      meeting_id: this.attr(null),
      media: this.attr(null),
      media_id: this.attr(null),
      type: this.attr(null),
      created: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
